<div cdkDrag 
cdkDragRootElement=".cdk-overlay-pane" cdkDragHandle class="dialog-header">
  <h2 mat-dialog-title>Select a Department</h2>
  <mat-icon>drag_indicator</mat-icon>
</div>
<mat-dialog-content class="mat-typography">
  <mat-form-field appearance="fill" style="width: 100%;">
    <mat-label>Filter by Title or Key</mat-label>
    <input matInput [(ngModel)]="searchTerm" (ngModelChange)="onSearchTermChange()"
      placeholder="Search" />
    </mat-form-field>

    <mat-selection-list>
      @for (dept of filteredDepts; track dept) {
        <mat-list-option [value]="dept" (click)="onSelectDept(dept)"
          [selected]="selectedDept === dept">
          {{ dept.name }} ({{ dept.key }})
        </mat-list-option>
      }
    </mat-selection-list>
  </mat-dialog-content>

  <mat-dialog-actions align="end">
    <button mat-flat-button color="primary" [disabled]="!selectedDept" (click)="onSelectClick()">
      Select
    </button>
    <button mat-button (click)="onCancelClick()">Cancel</button>
  </mat-dialog-actions>